import mongeService from "@/CommonDP/mongeView/service/monge-service";

// 获得截图文件
export async function getPicFile(url) {
  const blob = dataURItoBlob(url);
  const formData = new FormData();
  formData.set("files", blob);
  const res = await mongeService.picUploadNew(formData);
  if (res.result === "0") {
    return res.data[0];
  }
}

export function dataURItoBlob(base64Data) {
  let byteString;
  if (base64Data.split(",")[0].indexOf("base64") >= 0) {
    byteString = atob(base64Data.split(",")[1]);
  } else {
    byteString = unescape(base64Data.split(",")[1]);
  }
  const mimeString = base64Data.split(",")[0].split(":")[1].split(";")[0];
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([ia], { type: mimeString });
  return blob;
}
